<template>
  <v-container grid-list-lg fluid>
    <div class="text-center text-h4">Report Center</div>
    <v-list class="mt-5">
      <!-- <v-subheader>User Controls</v-subheader> -->
      <v-subheader inset>Batch</v-subheader>
      <v-list-item @click="openReport('batchSelection')">
        <v-list-item-avatar>
          <v-icon class="blue darken-1" dark>
            mdi-account-convert
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Batch Report</v-list-item-title>
          <v-list-item-subtitle>View any batch report for any location</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-subheader inset>P&L Reports</v-subheader>
      <v-list-item to="pnlReport">
        <v-list-item-avatar>
          <v-icon class="deep-purple darken-1" dark>
            mdi-chart-bar
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Profit & Lose Report</v-list-item-title>
          <v-list-item-subtitle>Get all of location P&L report in one place. </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-subheader inset>Transactions</v-subheader>
      <v-list-item @click="openReport('invoiceList')">
        <v-list-item-avatar>
          <v-icon class="blue darken-1" dark>
            mdi-receipt
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Receipts</v-list-item-title>
          <v-list-item-subtitle>Sales receipt by date</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="openReport('openRepairList')">
        <v-list-item-avatar>
          <v-avatar size="50" color="green darken-1">
            <v-img contain class="mr-2" height="25" src="@/assets/hammer-screwdriver.png">
            </v-img>
          </v-avatar>


          <!-- <v-icon class="green darken-1" dark>
            mdi-receipt
          </v-icon> -->
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Open Repair</v-list-item-title>
          <v-list-item-subtitle>List of open repairs</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>



    </v-list>

    <v-dialog v-model="dialog" width="350" persistent>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Select Location
        </v-card-title>
        <v-container grid-list-lg>
          <v-select outlined dense @change="locationChange" :items="locations" v-model="selectedLocation"
            label="Select Store" hide-details return-object item-text="businessName"></v-select>
        </v-container>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'report-selection',
  data() {
    return {
      selectedLocation: null,
      dialog: false,
      selectedRouter: null,
    }
  },
  // watch: {
  //   selectedLocation(val) {
  //     console.log('selectedLocation', val, this.selectedRouter)

  //   }
  // },
  computed: {
    ...mapGetters('location', ['locations'])
  },
  methods: {
    ...mapActions('report', ['resetLocation', 'setSelectedLocation']),
    locationChange() {
      this.setSelectedLocation(this.selectedLocation)
      switch (this.selectedRouter) {
        case 'batchSelection':
          this.$router.push({ name: 'Batch-selection', params: { location: this.selectedLocation } });
          break;
        case 'invoiceList':
          this.$router.push({ name: 'invoice-list', params: { location: this.selectedLocation } });
          break;
        case 'openRepairList':
          this.$router.push({ name: 'openRepair-list', params: { location: this.selectedLocation } });
          break;
      }
    },
    openReport(val) {
      this.selectedLocation = null
      this.resetLocation()
      this.selectedRouter = val
      this.dialog = !this.dialog
    }
  }
}
</script>

<style scoped>
</style>